import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@redux/store";
import React, { useMemo } from "react";
import { SHCheckbox } from "@components/design-systems";
import {
  addSelectedRowIds,
  removeSelectedRowIds,
} from "@redux/slices/model-screener";

type MSTableSelectedRowCheckboxProps = {
  rowId: string;
};

export const MSTableSelectedRowCheckbox = React.memo(
  ({ rowId }: MSTableSelectedRowCheckboxProps) => {
    const dispatch = useAppDispatch();
    const selectedRowIds = useSelector(
      (state: RootState) => state.modelScreener.selectedRowIds,
    );

    const isSelected = useMemo(
      () => !!selectedRowIds[rowId],
      [selectedRowIds, rowId],
    );

    const handleOnCheckboxClicked = () => {
      dispatch(
        isSelected ? removeSelectedRowIds(rowId) : addSelectedRowIds(rowId),
      );
    };

    return (
      <SHCheckbox checked={isSelected} onChange={handleOnCheckboxClicked} />
    );
  },
);
